import "./AddPatientByCode.css";
import {Button, Col, Form, Input, Modal, Row, Space, Spin} from "antd";
import {useTranslation} from "react-i18next";
import {useAppDispatch, useAppSelector} from "../app/hooks";
import {Problem} from "../model/problem";
import {PatientResponseDto} from "../api/client-axios";
import {useNavigate} from "react-router-dom";
import {
    clearAddPatientByCodeError,
    getPatientByCode,
    initAddPatientByCodeState,
    setActivationCode
} from "../features/addPatientByCode";
import {initAddPatientState} from "../features/addPatientSlice";


export const AddPatientByCode = (props: {
    onConfirm: (patient: PatientResponseDto) => void,
    organizationId: string
}) => {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const {t} = useTranslation();
    const status = useAppSelector((state) => state.addPatientByCode.status);
    const error = useAppSelector((state) => state.addPatientByCode.error);
    const patient = useAppSelector((state) => state.addPatientByCode.patient);
    const code = useAppSelector((state) => state.addPatientByCode.activationCode);


    const onSend = () => {
        dispatch(getPatientByCode({code: code, organizationId: props.organizationId}));
    }

    const onChangeCode = (value: string) => {
        dispatch(setActivationCode(value));
    }

    const isModalVisible = status == "error" || status == "auth-error";

    const handleAuthOk = () => {
        dispatch(clearAddPatientByCodeError())
        // dispatch(clearAddPatientByCodeError())
        // navigate("/")
    }

    const handleErrorOk = () => {
        dispatch(clearAddPatientByCodeError())
    }

    const handleCancel = () => {
        dispatch(clearAddPatientByCodeError())
    }


    if (status === "loading") {
        return <Spin/>
    }

    if (status === "auth-error") {
        return <Modal title={t("error.auth")} visible={isModalVisible} onOk={handleAuthOk} onCancel={handleCancel}>
            <p>{t("error.authFailedNotAllowed")}</p>
        </Modal>
    }


    if (status === "error" /*&& confirmMode !== ConfirmMode.Send*/) {
        const apiError = error as Problem;
        const title = apiError?.title ?? t("error.server");
        const detail = apiError?.detail ?? "";
        return <Modal title={title} visible={isModalVisible} onOk={handleErrorOk} onCancel={handleCancel}>
            <p>{detail}</p>
        </Modal>
    }


    if (patient?.userAccount?.id != null) {
        props.onConfirm(patient);
        dispatch(initAddPatientByCodeState());
    }

    const onCancel = () => {
        dispatch(initAddPatientByCodeState());
        navigate(-1);
    }


    return (<div className="main-frame">
        <Form className='form'
              name="add-patient"
              labelCol={{span: 8}}
              wrapperCol={{span: 24}}
              initialValues={{remember: true}}
              autoComplete="off"
        >
            <Form.Item initialValue={code} help={t("help.activationCode")} name="activationCode"
                       label={t("field.code")} rules={[{required: true, message: t("validation.codeRequired")}]}>

                <Input type="tel" placeholder={t("placeholder.activationCode")} value={code} onChange={(e) => onChangeCode(e.target.value)}/>
            </Form.Item>
            <Form.Item wrapperCol={{offset: 8, span: 24}}>
                <Row>
                    <Col span={24} style={{textAlign: 'right'}}>
                        <Space>
                            <Button onClick={onCancel}>{t("actions.cancel")}</Button>
                            <Button type='primary' onClick={onSend}>{t("actions.send")}</Button>
                        </Space>
                    </Col>
                </Row>
            </Form.Item>
        </Form>
    </div>)
}


